<template>
  <div>
    <button
        class="btn my-2 my-sm-0 float-left btn-outline-primary"
        style="width: 120px; margin-left: 20px;"
        @click="addLogItem"
        :disabled="!isAddLogAllowed"
    >
      Перенести дату
    </button>
    <button
        class="btn my-2 my-sm-0 float-left btn-outline-primary"
        style="width: 150px; margin-left: 20px;"
        @click="addCommentItem"
    >
      Добавить комментарий
    </button>
    <br>
    <br>
    <p v-if="error" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ error }}</strong>
    </p>
    <br>

    <div class="container invoice-table">

      <table class="table table-sm text-left" style="width: 200px">
        <thead>
        <tr>
          <th style="width: 50px">Платёж</th>
          <th style="width: 50px">Сумма</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(p, i) in paymentTransactions">
          <td>
            <router-link :to="{name: 'payment', params:{
                            id: p.PaymentID,
                        }}">
              {{ p.PaymentID }}
            </router-link>
          </td>
          <td>
            {{ p.AmountWithVat }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <br>
    <br>
    <div class="container invoice-table">

      <table class="table table-sm text-left">
        <thead>
        <tr>
          <th style="width: 120px">Дата</th>
          <th style="width: 650px">Комментарий</th>
          <th v-if="isSuperAdmin" style="width: 150px" class="text-center">Невозвратный</th>
          <th style="width: 135px">Плановая дата</th>
          <th style="width: 40px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(l, i) in arrearsLog">
          <td>
            <div v-if="!l.isNew" class="float-left">
              {{ l.time_created }}
            </div>
          </td>
          <td style="width: 640px">

            <div v-if="!l.isNew" class="float-left">
              {{ l.comment }}
            </div>
            <div v-if="l.isNew">
              <input type="text" size="80" v-model="l.comment">
            </div>
          </td>
          <td v-if="isSuperAdmin" class="text-center">
            <div v-if="l.type === 'dateChange'">
              <div v-if="l.isNew">
                <input
                    type="checkbox"
                    v-model="l.isIrretrievableDebt"
                >
              </div>
            </div>
          </td>
          <td>
            <div v-if="l.type === 'dateChange'">
              <div v-if="!l.isIrretrievableDebt">
                <div v-if="!l.isNew" class="float-left">
                  {{ l.time_completed }}
                </div>
                <div v-if="l.isNew">
                  <input
                      type="date"
                      @change="onDateChange"
                      v-model="l.time_completed"
                      style="width: 135px"
                  >
                </div>
              </div>
            </div>
          </td>
          <td class="text-center"><i v-if="l.isNew && isSaveLogAllowed" @click="changeDueDate(i)"
                                     class="far fa-save cursor-pointer float-right"
                                     style="font-size: 22px; padding-top: 3px; color: #007bff"></i></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const oneDay = 24 * 60 * 60 * 1000;
let maxDays = 7

export default {
  name: 'InvoiceArrearsLog',
  data() {
    return {
      doc_id: null,
      newDocId: null,
      arrearsLog: [],
      paymentTransactions: [],
      invoice: null,
      selectAllTasks: false,
      selectedMoveType: "existingDoc",
      error: null,
      moveInProgress: false,
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
    };
  },
  computed: {
    isSuperAdmin() {
      return this.$store.getters.isAdmin;
    },

    isAddLogAllowed() {
      let tSearch = this.arrearsLog.find(t => t.isNew === true);

      let today = new Date();

      let dueDate = today;
      if (this.invoice) {
        dueDate = new Date(this.invoice.due_date);
      }

      return (this.invoice && this.invoice.payment_type_id === 2 && this.invoice.debt_sum !== 0.0 && !this.invoice.is_irretrievable_debt && (dueDate < today) && (tSearch === undefined));
    },

    isSaveLogAllowed() {

      if  (this.invoice.due_date === undefined) {
        return false
      }

      let tSearch = this.arrearsLog.find(t => t.isNew === true);
      if (tSearch === undefined) {
        return false;
      } else {

        if (tSearch.comment.length < 6) {
          return false;
        }

        if (tSearch.type === "comment") {
          return true;
        }

        let limitDate = new Date(this.invoice.due_date)
        let dueDate = new Date(tSearch.time_completed)

        if (dueDate <= limitDate) {
          return false;
        }

        if (this.isSuperAdmin) {
          return true;
        }

        let diff = Math.round(Math.abs((dueDate - limitDate) / oneDay));
        if (diff > maxDays) {
          return false;
        }
      }

      return true;
    }

  },

  methods: {

    addLogItem() {

      let dueDate = new Date(this.invoice.due_date)
      dueDate.setDate(dueDate.getDate() + 7);

      let newLog = {
        id: 0,
        invoice_id: this.invoice.id,
        event_id: 13,
        user_id: 10,
        time_created: new Date().toISOString().split('T')[0],
        status: 0,
        comment: "",
        time_completed: dueDate.toISOString().split('T')[0],
        isNew: true,
        type: "dateChange"
      }

      this.arrearsLog.push(newLog);

    },

    addCommentItem() {

      let dueDate = new Date(this.invoice.due_date)

      let newLog = {
        id: 0,
        invoice_id: this.invoice.id,
        event_id: 13,
        user_id: 10,
        time_created: new Date().toISOString().split('T')[0],
        status: 0,
        comment: "",
        time_completed: dueDate.toISOString().split('T')[0],
        isNew: true,
        type: "comment"
      }

      this.arrearsLog.push(newLog);

    },

    changeDueDate(i) {

      let limitDate = new Date(this.invoice.due_date)
      let planDueDate = new Date(this.arrearsLog[i].time_completed)

      let diff = Math.round(Math.abs((planDueDate - limitDate) / oneDay));

      // this.error = "diff= " + diff + " tc= " + this.arrearsLog[i].time_completed;

      if (diff > maxDays && !this.isSuperAdmin) {
        this.error = "Перенос плановой даты оплаты возможен не более, чем на " + maxDays + " дней. Запрошено:" + diff;
        return;
      }

      // console.log(this.tasks[i]);


      let request = {
        dueDate: planDueDate.toISOString(),
        comment: this.arrearsLog[i].comment,
        isIrretrievableDebt: this.arrearsLog[i].isIrretrievableDebt,
        type: this.arrearsLog[i].type
      };

      if (this.arrearsLog[i].type === "dateChange") {
        request.comment = "Due date changed to " + planDueDate.toISOString().split('T')[0] + ". " + request.comment
      }

      console.log(request);

      axios.post(`/docs/` + this.invoice.id + `/change_due_date`, request)
          .then((res) => {
            this.arrearsLog[i].isNew = false;
            this.invoice.due_date = this.arrearsLog[i].time_completed;

            console.log(res.data);
            // location.reload();
          })
          .catch(error => {
            console.log(error)
            this.error = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });

    },

    onDateChange() {
      let tSearch = this.arrearsLog.find(t => t.isNew === true);

      if (tSearch === undefined) {

      }

      //tSearch.time_completed = new Date(tSearch.time_completed);
    },

  },


  beforeCreate() {


  },

  mounted() {
    this.doc_id = this.$route.params.doc_id;
    axios.defaults.headers.authorization = this.$store.state.token;

    axios.get(`/doc_by_id`, {
      params: {
        invoice_id: this.$route.params.doc_id,
        country_id: this.$route.params.countryID,
      },
    })
        .then((res) => {
          console.log(res.data);
          this.invoice = res.data;

          axios.get(`/docs/${this.invoice.id}/arrears_log`)
              .then((res) => {
                console.log(res.data);

                let arrearsLog = res.data;

                arrearsLog.forEach(l => {
                  l.time_created = new Date(l.time_created).toISOString().split('T')[0];

                  l.isNew = false;
                  l.isIrretrievableDebt = false;

                  if (l.time_completed.Valid) {
                    l.time_completed = new Date(l.time_completed.Time).toISOString().split('T')[0];
                  }

                });


                this.arrearsLog = arrearsLog;

              })
              .catch(error => console.log(error));

          axios.get(`/docs/${this.invoice.id}/payment_transactions`)
              .then((res) => {
                // console.log(res.data);
                this.paymentTransactions = res.data;
              })
              .catch(error => console.log(error));
        })
        .catch(error => console.log(error));


  }
  ,
}
;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.invoice-table {
  font-size: 14px;
  width: 1200px;
}

</style>
